(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-arrival-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sm-arrival-tip')) {
    customElements.define(
      'sm-arrival-tip',
      class extends HTMLElement {
        constructor() {
          super();
          this.onButtonClick = this.onButtonClick.bind(this);
          this.onPointerEnter = this.onPointerEnter.bind(this);
          this.onPointerLeave = this.onPointerLeave.bind(this);
          this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
          this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
        }

        connectedCallback() {
          this.button = this.querySelector('button');
          if (!this.button) return;
          if (!this.bound) {
            this.bound = true;
            this.button.addEventListener('click', this.onButtonClick);
            this.addEventListener('mouseenter', this.onPointerEnter);
            this.addEventListener('mouseleave', this.onPointerLeave);
          }
          document.addEventListener('pointerdown', this.onDocumentPointerDown);
          document.addEventListener('keydown', this.onDocumentKeydown);
        }

        disconnectedCallback() {
          document.removeEventListener('pointerdown', this.onDocumentPointerDown);
          document.removeEventListener('keydown', this.onDocumentKeydown);
        }

        onButtonClick() {
          const open = !this.classList.contains('is-open');
          if (open) this.placeCaret();
          this.setOpen(open);
          // Closed with the pointer still on it, the hover view would stay up
          // and the click would look like it did nothing.
          if (!open && this.matches(':hover')) this.classList.add('is-dismissed');
        }

        onPointerEnter() {
          this.placeCaret();
        }

        onPointerLeave() {
          this.classList.remove('is-dismissed');
        }

        // The panel is positioned against the button on a wide screen and against
        // the whole row on a narrow one; its offset parent is whichever applies.
        placeCaret() {
          const panel = this.querySelector('.sm-arrival-tabs__tip-panel');
          const origin = panel && panel.offsetParent;
          if (!origin) return;
          const button = this.button.getBoundingClientRect();
          const x = button.left + button.width / 2 - origin.getBoundingClientRect().left;
          this.style.setProperty('--sm-tip-caret-x', Math.round(x) + 'px');
        }

        onDocumentPointerDown(event) {
          if (!this.contains(event.target)) this.setOpen(false);
        }

        onDocumentKeydown(event) {
          if (event.key !== 'Escape') return;
          if (this.classList.contains('is-open')) {
            this.setOpen(false);
            this.button.focus();
          }
          if (this.matches(':hover')) this.classList.add('is-dismissed');
        }

        setOpen(open) {
          this.classList.toggle('is-open', open);
          this.button.setAttribute('aria-expanded', String(open));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
